import React from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, Alert, ModalFooter } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Storage, Translate, translate } from 'react-jhipster';
import '../../user/profile.scss';
import '../../../sendOtp/sendOtp.scss';
import OtpInput from 'react-otp-input';
import { reSendOtp, sendOtp } from 'app/modules/sendOtp/sendOtp.reducer';
import { actionImageMap, IND, MESSAGE, Rester_Type, STATUS_TYPES } from 'app/config/constants';
import { generateCaptcha } from 'app/modules/account/password-reset/password-reset.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Table } from 'semantic-ui-react';
import { handleGetUserList } from 'app/modules/administration/approve-management/approve-management.reducer';
import moment from 'moment';

export interface IListCancelAccountProps extends StateProps, DispatchProps {
  isDisplay: boolean;
  invokeCloseModal: Function;
  showModalInfoUser: Function;
}

export interface IListCancelAccountState {
  visible: boolean;
  color: string;
  message: string;
  isDisable: boolean;
  redirectUrl: boolean;
  alertMess: string;
  isOpenAlert: boolean;
}

export class ListCancelAccount extends React.Component<IListCancelAccountProps, IListCancelAccountState> {
  state: IListCancelAccountState = {
    visible: false,
    color: 'info',
    message: '',
    isDisable: false,
    redirectUrl: false,
    alertMess: '',
    isOpenAlert: false
  };

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  toggle = () => {
    this.props.invokeCloseModal();
  };
  onDismiss = () => {
    this.setState({ visible: false });
  };

  formatDate = dateString => {
    return moment(dateString).format('DD/MM/YYYY');
  };

  render() {
    return (
      <div className="container-fluid">
        <Modal
          className="modal-lg hide-border-bottom-modal"
          isOpen={this.props.isDisplay}
          toggle={this.toggle}
          size="lg"
          backdrop="static"
          centered={window.location === window.parent.location}
          style={{ maxWidth: window.innerWidth < 768 ? '100%' : '45%' }}
        >
          <ModalHeader toggle={this.toggle}>
            <h3 className="font-weight-bold">Danh sách đăng ký hủy tài khoản</h3>
          </ModalHeader>
          <ModalBody className="custom-scrollbar" style={{ paddingTop: '0px', paddingLeft: '2%', overflow: 'auto' }}>
            <Table responsive striped>
              <thead>
                <tr>
                  <th>{this.props.userProfile && this.props.userProfile.userType === '1' ? 'Họ và tên' : 'Tên tổ chức'}</th>
                  <th>Trạng thái</th>
                  <th>Ngày đăng ký</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {this.props.userList.map(item => (
                  <tr>
                    <td>{item['fullName']}</td>
                    <td>{STATUS_TYPES['CANCEL_ACCOUNT'][item['status']]}</td>
                    <td>{item['requestDate'] ? this.formatDate(item['requestDate']) : ''}</td>
                    <td>
                      <Button color="white" className="mr-1" onClick={() => this.props.showModalInfoUser(item)}>
                        <img src={require('app/images/eye.png')} alt="" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  userList: storeState.approveManagement.userList,
  userProfile: storeState.userInfo.userProfile
});
const mapDispatchToProps = {};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListCancelAccount);
